import { ICompteSalaire } from './compte-salaire.model';
import { ICompte } from './compte.model';
import { IAnneeScolaire } from './anneeScolaire.model';
export interface IEcole {
  id?: any;
  nom?: string | null;
  adresse?: string | null;
  telephone?: string | null;
  email?: string | null;
  logoId?: string | null;
  resetStatus?: StatusEcole;
  compte: ICompte;
  compteSalaire: ICompteSalaire;
  anneeScolaire?: IAnneeScolaire;
}

export enum StatusEcole {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export const defaultValue: Readonly<IEcole> = {
  id: null,
  nom: '',
  adresse: '',
  telephone: '',
  email: '',
  logoId: null,
  resetStatus: StatusEcole.COMPLETED,
  compte: null,
  anneeScolaire: null,
  compteSalaire: { solde: 0 },
};
